import { defineStore } from 'pinia';

const STORAGE_KEY = 'vsf-recently-viewed-products';
const MAX_SKUS_SIZE = 10; // max qty of stored skus. Stored skus qty and loaded products qty are made greater that showed in slider qty just in case that some products will become disabled and those will not be able to be loaded

interface RecentlyViewedProductsState {
  loaded: boolean,
  skus: string[],
}

const saveSkus = (store: RecentlyViewedProductsState) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store.skus));
  } catch (e) {
    console.error(e);
  }
}

export const useRecentlyViewedProductsStore = defineStore('recently-viewed-products', {
  state: (): RecentlyViewedProductsState => ({
    loaded: false,
    skus: []
  }),
  actions: {
    loadSkus () {
      try {
        const value = window.localStorage.getItem(STORAGE_KEY);
        if (value) {
          const skus = JSON.parse(value);
          if (Array.isArray(skus)) {
            this.skus = skus;
            this.loaded = true;
            return;
          }
        }
      } catch (e) {
        console.error(e);
      }
      this.skus = [];
      this.loaded = true;
    },
    addSku (sku) {
      if (this.skus.includes(sku)) {
        this.skus = this.skus.filter(_sku => _sku !== sku);
      }
      this.skus.unshift(sku);
      if (this.skus.length > MAX_SKUS_SIZE) {
        this.skus = this.skus.slice(0, MAX_SKUS_SIZE);
      }
      saveSkus(this);
    }
  },
});
